"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullScreen = void 0;
const react_1 = __importStar(require("react"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const Fullscreen_1 = __importDefault(require("@material-ui/icons/Fullscreen"));
exports.FullScreen = (0, react_1.memo)(({ element }) => {
    const toggleFullScreen = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (document.fullscreenElement) {
            document.exitFullscreen();
        }
        else {
            if (element)
                element.requestFullscreen();
        }
    };
    return (react_1.default.createElement(Tooltip_1.default, { title: `${document.fullscreenElement ? 'Exit' : 'Enter'} Full Screen` },
        react_1.default.createElement(Fullscreen_1.default, { style: { color: 'white', cursor: 'pointer' }, onClick: toggleFullScreen })));
});
//# sourceMappingURL=full-screen.js.map